import { ProcessedSubHead } from "@app/types/Opensearch";
import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import Heading from "@elements/Typography/Heading";
import { twMerge } from "tailwind-merge";

type SubHeadProps = {
  element: ProcessedSubHead;
  className?: string;
  isMobile?: boolean;
};

export default function SubHead({
  element,
  className,
  isMobile = false,
}: SubHeadProps) {
  const appliedClass = isMobile
    ? undefined
    : twMerge("font-medium text-xl text-black-300", className);
  return (
    <Heading className={appliedClass} Element={element.headingTag}>
      {ApplyParagraphAnnotations(element.subhead, element.annotations)}
    </Heading>
  );
}
